import { PHILOSOPHY_STATEMENTS } from "@/lib/constants";
import { useReveal } from "@/hooks/useReveal";

const Statement = ({ text, delay }) => {
  const { ref, shown } = useReveal();
  return (
    <div
      ref={ref}
      className={`reveal ${shown ? "in" : ""} border-t border-border py-8 sm:py-10`}
      style={{ transitionDelay: `${delay}ms` }}
      data-testid={`philosophy-statement-${delay}`}
    >
      <p className="font-serif text-3xl sm:text-4xl lg:text-5xl text-primary leading-tight tracking-tight text-balance">
        {text}
      </p>
    </div>
  );
};

export const Philosophy = () => {
  return (
    <section
      id="philosophy"
      data-testid="philosophy-section"
      className="py-24 sm:py-32 border-t border-border"
    >
      <div className="max-w-5xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center mb-16 sm:mb-20">
          <div className="flex items-center justify-center gap-4 mb-8">
            <span className="h-px w-10 bg-accent" />
            <span className="text-[11px] uppercase tracking-[0.32em] text-accent font-semibold">
              Philosophy
            </span>
            <span className="h-px w-10 bg-accent" />
          </div>
          <h2
            data-testid="philosophy-headline"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl text-primary leading-[1.05] tracking-tight text-balance"
          >
            Built with restraint. <br className="hidden sm:block" />
            <em className="italic">Designed to compound.</em>
          </h2>
          <p className="mt-8 text-lg text-muted-foreground max-w-2xl mx-auto text-pretty">
            The best companies are built by those who treat capital, product,
            and time as inseparable.
          </p>
        </div>

        <div>
          {PHILOSOPHY_STATEMENTS.map((s, i) => (
            <Statement key={s} text={s} delay={i * 120} />
          ))}
          <div className="border-t border-border" />
        </div>

        <div className="mt-20 text-center">
          <div className="inline-flex items-center gap-6">
            <span className="h-px w-12 bg-accent" />
            <p
              data-testid="philosophy-closing"
              className="font-serif italic text-2xl sm:text-3xl text-primary"
            >
              Build things useful enough to last.
            </p>
            <span className="h-px w-12 bg-accent" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Philosophy;
